import { API_ENDPOINTS } from '@/config/api';
import { apiClient } from '@/services/api/client';
import type {
  ForgotPasswordPayload,
  LoginCredentials,
  LoginResponse,
  MessageResponse,
  ResetPasswordPayload,
} from '@/types/auth';

export const authApi = {
  async login(credentials: LoginCredentials): Promise<LoginResponse> {
    const { rememberMe: _, ...payload } = credentials;
    const { data } = await apiClient.post<LoginResponse>(API_ENDPOINTS.auth.login, payload);
    return data;
  },

  async logout(refreshToken: string): Promise<void> {
    await apiClient.post(API_ENDPOINTS.auth.logout, { refreshToken });
  },

  async forgotPassword(payload: ForgotPasswordPayload): Promise<MessageResponse> {
    const { data } = await apiClient.post<MessageResponse>(
      API_ENDPOINTS.auth.forgotPassword,
      payload,
      { skipSuccessToast: true },
    );
    return data;
  },

  async resetPassword(payload: ResetPasswordPayload): Promise<MessageResponse> {
    const { data } = await apiClient.post<MessageResponse>(
      API_ENDPOINTS.auth.resetPassword,
      payload,
      { skipSuccessToast: true },
    );
    return data;
  },

  async verifyResetToken(token: string): Promise<MessageResponse> {
    const { data } = await apiClient.get<MessageResponse>(
      API_ENDPOINTS.auth.verifyResetToken(token),
      { skipErrorToast: true },
    );
    return data;
  },
};
